<template>
	<Pupup
		@close="closePupup"
		v-if="showPupup"
		:title="pupupTitle"
		:brandId="actionBrandId"
		:width="doAction === 'connect' ? 800 : 600"
		:showClose="true"
		key="pupup2">
		<template v-slot:content>
			<div class="pupup-content-wrap">
				<div class="pupup-content-inner" v-if="!!showMessageInfo">
					<p class="connect-message message-p">
						<span v-html="showMessageInfo.message" class="message" />
					</p>
					<hr v-if="showMessageInfo.partnershipTypes && showMessageInfo.partnershipTypes.length > 0" />
					<p class="connect-message" v-if="showMessageInfo.partnershipTypes && showMessageInfo.partnershipTypes.length > 0">
						They showed an interest in the following...<br />
						<span v-for="(partnershipType, index) in showMessageInfo.partnershipTypes" :key="'partnershipType-' + index">
							<span v-if="index === showMessageInfo.partnershipTypes.length - 1 && showMessageInfo.partnershipTypes.length > 1">
								and
							</span>
							<span class="partnership-type">{{ partnershipType }}</span
							><span v-if="index < showMessageInfo.partnershipTypes.length - 2">, </span>
						</span>
					</p>
				</div>
				<div class="pupup-content-inner" v-if="doAction === 'connect'">
					<p class="connect-message">We've made it easy to introduce yourself.</p>

					<p class="connect-message">
						Select the partnerships you are interested in or leave it blank if you are open to anything.
						<span v-if="partnershipInMind.length === 1"><br />*You can select multiple partnerships if you like*</span>
					</p>

					<v-select
						placeholder="Please select the partnership(s)"
						v-model="partnershipInMind"
						:options="whatPartnershipsDropdown"
						:reduce="(option) => option.id"
						:multiple="true"
						:append-to-body="true"
						:searchable="whatPartnershipsDropdown.length > 20">
						<template #search="{ attributes, events }">
							<input :readonly="isMobile" class="vs__search" v-bind="attributes" v-on="events" />
						</template>
					</v-select>

					<p class="connect-message top-margin" v-if="matchBrand && matchBrand.brand_name">
						Send {{ matchBrand.brand_name }} a message to introduce yourself, your brand and your collaboration idea!
					</p>
					<p class="connect-message top-margin" v-else>
						Send them a message to introduce yourself, your brand and your collaboration idea!
					</p>

					<FormInput
						type="textarea"
						v-model="connectMessage"
						:required="false"
						:rows="5"
						:noMarginBottom="true"
						class="connect-message-input"
						placeholder="Enter your message" />
				</div>
				<div class="pupup-content-inner" v-if="doAction === 'decline'">
					<p class="connect-message">
						Don't worry we'll send them a nice message on your behalf and <strong>we won't share any of your details</strong>.<br /><br />
						Please choose which best describes your reason why...
					</p>
				</div>
				<div class="pupup-content-inner" v-if="doAction === 'already'">
					<p class="connect-message">Please confirm you want to decline this brand because you've already collaborated.</p>
				</div>
				<div class="pupup-content-inner" v-if="doAction === 'cancel' || doAction === 'cancel-temp'">
					<p class="connect-message">Are you sure you want to cancel this request?</p>
				</div>
				<div class="pupup-content-inner" v-if="doAction === 'confirm'">
					<p class="connect-message">
						This is an exciting brand collaboration! Once you confirm, contact details for
						{{ matchBrand && matchBrand.brand_name ? matchBrand.brand_name : "this brand" }} will appear. We will also share a copy of
						your contact details with them.
					</p>
				</div>
				<div class="pupup-content-inner" v-if="doAction === 'snooze'">
					<p class="connect-message">
						Please confirm you are happy to snooze
						<strong>{{ matchBrand && matchBrand.brand_name ? matchBrand.brand_name : "this brand" }}</strong> for up to 2 months, you can
						connect or decline at anytime within this period.
					</p>
				</div>
				<div class="pupup-content-inner" v-if="doAction === 'uninterest'">
					<p class="connect-message">
						Click OK and this match will move to your Declines area, you can still connect with them through your Declines area if you
						change your mind.
					</p>
				</div>
				<div class="pupup-content-inner" v-if="doAction === 'revert'">
					<p class="connect-message">Add this brand back to matches?</p>
				</div>
				<div :class="{ 'pupup-content-inner': true, [doAction]: true }" v-if="doAction === 'contact' && matchBrand">
					<Icon type="email" class="svg" />
					<p class="connect-message">
						<span>
							<strong>{{ matchBrand.fname }} {{ matchBrand.sname }}</strong> from <strong>{{ matchBrand.company_name }}</strong>
							<br />can be reached at <a :href="'mailto:' + matchBrand.email">{{ matchBrand.email }}</a> <br />Take this off of
							PartnerUp and go introduce yourself!
						</span>
					</p>
				</div>
			</div>
		</template>
		<template v-slot:footer-inner v-if="showActionFooter">
			<div class="button-wrap">
				<template v-if="showMessageInfo && type === 'requests'">
					<span class="button flip-colours no-case no-margin has-svg" @click="emitAction('confirm')">
						<span><Icon type="connections" class="svg" colour="#ffffff" /> <span>Connect</span></span>
					</span>
					<span class="button flip-colours no-case no-margin has-svg" @click="emitAction('snooze')">
						<span><Icon type="snooze" class="svg" colour="#ffffff" /> <span>Snooze</span></span>
					</span>
					<span class="button flip-colours no-case no-margin has-svg" @click="emitAction('decline')">
						<span><Icon type="declines" class="svg" colour="#ffffff" /> <span>Decline</span></span>
					</span>
				</template>
				<template v-else-if="doAction === 'connect'">
					<span class="button hollow no-case no-margin" @click="closePupup">Cancel</span>
					<span class="button flip-colours no-case no-margin" @click="emitAction(doAction)">OK</span>
				</template>
				<template v-else-if="doAction === 'decline'">
					<span class="button flip-colours no-case no-margin" @click="emitAction(doAction)">Not the right fit</span>
					<span class="button hollow no-case no-margin" @click="emitAction('decline-already')">Already collaborated</span>
				</template>
				<template v-else-if="doAction === 'already'">
					<span class="button hollow no-case no-margin" @click="closePupup">Go back</span>
					<span class="button flip-colours no-case no-margin" @click="emitAction(doAction)">Confirm</span>
				</template>
				<template v-else-if="doAction === 'cancel' || doAction === 'cancel-temp'">
					<span class="button hollow no-case no-margin" @click="closePupup">Go back</span>
					<span class="button flip-colours no-case no-margin" @click="emitAction(doAction, true)">Yes please cancel it</span>
				</template>
				<template v-else-if="doAction === 'confirm'">
					<span class="button hollow no-case no-margin" @click="closePupup">Go back</span>
					<span class="button flip-colours no-case no-margin" @click="emitAction(doAction)">Confirm</span>
				</template>
				<template v-else-if="doAction === 'snooze'">
					<span class="button hollow no-case no-margin" @click="closePupup">Go back</span>
					<span class="button flip-colours no-case no-margin" @click="emitAction(doAction)">Snooze it!</span>
				</template>
				<template v-else-if="doAction === 'uninterest'">
					<span class="button hollow no-case no-margin" @click="closePupup">Cancel</span>
					<span class="button flip-colours no-case no-margin" @click="emitAction(doAction)">OK</span>
				</template>
				<template v-else-if="doAction === 'revert'">
					<span class="button hollow no-case no-margin" @click="closePupup">Cancel</span>
					<span class="button flip-colours no-case no-margin" @click="emitAction(doAction)">Add back</span>
				</template>
			</div>
		</template>
	</Pupup>

	<Pupup
		@close="emitCloseReport"
		v-if="showReportBrand"
		:brandId="showReportBrand"
		:showClose="true"
		:width="500"
		:full="false"
		key="pupup3"
		title="I'm having some issues...">
		<template v-slot:content>
			<div class="pupup-content-wrap">
				<form class="pupup-content-inner report-brand">
					<p>
						PartnerUp is to be used for mutually beneficial marketing purposes, we want all our brands to have a good experience and if
						you believe a business on here is not using PartnerUp correctly, please report them here so we can look into this.
					</p>

					<FormInput
						type="textarea"
						v-model="reportMessage"
						name="report-message"
						theRef="report-message"
						:autoResize="true"
						:autoResizeMaxHeight="240"
						:noMarginBottom="true"
						:required="false"
						class="text-box"
						label="Please tell us why you are reporting this brand" />
				</form>
			</div>
		</template>
		<template v-slot:footer-inner>
			<div class="button-wrap">
				<span class="button" @click="emitSubmitReport">Submit</span>
			</div>
		</template>
	</Pupup>

	<Pupup @close="emitCloseBadgeInfo" v-if="showBadgeInfo" :showClose="true" :width="800" :full="false" key="pupup4" :title="badgeInfoModal.title">
		<template v-slot:content>
			<div class="pupup-content-wrap">
				<form class="pupup-content-inner badge-info">
					<Icon :type="badgeInfoModal.icon" class="svg" colour="rgba(0, 0, 0, 0.56)" />

					<p v-html="badgeInfoModal.description"></p>
				</form>
			</div>
		</template>
	</Pupup>

	<Pupup @close="closeToggleShowInfo" v-if="showingToggleShowInfoPupup" :showClose="true" :width="500" :full="false" key="pupup6" title="">
		<template v-slot:content>
			<ToggleShowBrand :show_info="!!userBrand && !!userBrand.show_info" :brandId="brand" @success="emitToggledShowInfo" />
		</template>
	</Pupup>
</template>

<script>
import { computed } from "vue";
import { useRoute } from "vue-router";
import { useVueInstance } from "../../composables/useVueInstance";
import general from "../../utils/general";
import Pupup from "./Pupup.vue";
import FormInput from "../Form/Input.vue";
import Icon from "./BaseIcon.vue";
import ToggleShowBrand from "../ToggleShowBrand.vue";

export default {
	name: "BrandActionOverlays",
	components: { Pupup, FormInput, Icon, ToggleShowBrand },
	setup() {
		const { store } = useVueInstance();
		const route = useRoute();
		const brandActionUi = computed(() => store.state.general.brandActionUi || {});
		const brandCardPopup = computed(() => store.state.general.brandCardPopup || {});
		const updateBrandActionUi = (payload) => store.commit("general/updateBrandActionUi", payload);
		const eventSource = computed(() => brandActionUi.value.source || brandCardPopup.value.source || "brands");
		const setBrandActionEvent = (type, payload) => {
			store.commit("general/setBrandActionEvent", { type, payload, source: eventSource.value, createdAt: Date.now() });
		};

		const type = computed(() => (route?.name ? String(route.name).split("-")[0] : ""));
		const brand = computed(() => store.state.general.brand);
		const userBrands = computed(() => store.state.general.userBrands || []);
		const userBrand = computed(() => {
			if (!userBrands.value || userBrands.value.length === 0) return null;
			const byId = userBrands.value.find((item) => item.id === brand.value);
			return byId || userBrands.value[0] || null;
		});

		const showPupup = computed(() => brandActionUi.value.showPupup);
		const doAction = computed(() => brandActionUi.value.doAction || "");
		const actionBrandId = computed(() => brandActionUi.value.actionBrandId || null);
		const matchBrand = computed(() => brandActionUi.value.matchBrand || null);
		const connectMessage = computed({
			get: () => brandActionUi.value.connectMessage || "",
			set: (value) => updateBrandActionUi({ connectMessage: value }),
		});
		const partnershipInMind = computed({
			get: () => brandActionUi.value.partnershipInMind || [],
			set: (value) => updateBrandActionUi({ partnershipInMind: value }),
		});
		const showMessageInfo = computed(() => brandActionUi.value.showMessageInfo);
		const previousMessageInfo = computed(() => brandActionUi.value.previousMessageInfo);
		const showReportBrand = computed(() => brandActionUi.value.showReportBrand);
		const reportMessage = computed({
			get: () => brandActionUi.value.reportMessage || "",
			set: (value) => updateBrandActionUi({ reportMessage: value }),
		});
		const showBadgeInfo = computed(() => brandActionUi.value.showBadgeInfo);
		const badgeInfoKey = computed(() => brandActionUi.value.badgeInfoKey || "");
		const badgeInfoModal = computed(() => {
			const key = badgeInfoKey.value || "top_responder";
			const badgeInfoMap = {
				top_responder: {
					title: "Top Responders",
					icon: "top-responder",
					description:
						"Top Responder badges recognize brands that consistently acknowledge all their requests - even if they need to decline or snooze them. By never leaving other brands hanging, they help make PartnerUp a more effective platform for everyone.",
				},
				popular_now: {
					title: "Popular",
					icon: "popular_now",
					description:
						"Popular badges highlight brands that are receiving strong recent interest on PartnerUp. They are seeing an above-average volume of incoming requests right now.",
				},
			};
			return badgeInfoMap[key] || badgeInfoMap.top_responder;
		});
		const showingToggleShowInfoPupup = computed(() => brandActionUi.value.showingToggleShowInfoPupup);
		const whatPartnershipsDropdown = computed(() => brandActionUi.value.whatPartnershipsDropdown || []);
		const isMobile = computed(() => general.isMobile());

		const pupupTitle = computed(() => {
			if (showMessageInfo.value) {
				return showMessageInfo.value.title || null;
			}
			switch (doAction.value) {
				case "connect":
					return matchBrand.value && matchBrand.value.brand_name
						? `Send a request to connect with ${matchBrand.value.brand_name}`
						: `Send a request to connect`;
				case "confirm":
					if (matchBrand.value && matchBrand.value.brand_name) {
						return `Connect with ${matchBrand.value.brand_name}`;
					}
					return `Connect`;
				case "decline":
				case "already":
					return "Decline this brand?";
				case "snooze":
					return "Snooze this request?";
				case "cancel":
				case "cancel-temp":
					return "Cancel this request?";
				case "uninterest":
					return "Not interested";
				case "revert":
					return "Reverse decline";
				case "contact":
					return "Contact this brand";
			}
			return null;
		});
		const showActionFooter = computed(() => {
			if (showMessageInfo.value && type.value === "requests") return true;

			return ["connect", "decline", "already", "cancel", "cancel-temp", "confirm", "snooze", "uninterest", "revert"].includes(doAction.value);
		});

		const emitAction = (action, forceIt) => {
			setBrandActionEvent("actioner", { brandId: actionBrandId.value, action, forceIt });
		};

		const closePupup = () => {
			setBrandActionEvent("closePupup", {
				isSingleBrand: false,
				restorePreviousMessage: !!doAction.value && !!previousMessageInfo.value,
			});
		};

		const emitSubmitReport = () => {
			setBrandActionEvent("submitReportBrand");
		};

		const emitCloseReport = () => {
			setBrandActionEvent("closeReportPupup");
		};

		const emitCloseBadgeInfo = () => {
			setBrandActionEvent("closeBadgeInfoPupup");
		};

		const emitToggledShowInfo = () => {
			setBrandActionEvent("toggledShowInfo");
		};

		const closeToggleShowInfo = () => {
			updateBrandActionUi({ showingToggleShowInfoPupup: false });
		};

		return {
			type,
			brand,
			userBrand,
			showPupup,
			doAction,
			actionBrandId,
			matchBrand,
			connectMessage,
			partnershipInMind,
			showMessageInfo,
			showReportBrand,
			reportMessage,
			showBadgeInfo,
			badgeInfoKey,
			badgeInfoModal,
			showingToggleShowInfoPupup,
			whatPartnershipsDropdown,
			isMobile,
			pupupTitle,
			showActionFooter,
			emitAction,
			closePupup,
			emitSubmitReport,
			emitCloseReport,
			emitCloseBadgeInfo,
			emitToggledShowInfo,
			closeToggleShowInfo,
		};
	},
};
</script>
<style lang="less" scoped>
@import "./../../assets/css/less/_settings.less";
.connect-message {
	&:first-child {
		margin-top: 0;
	}
	.partnership-type {
		font-weight: @bold;
	}
}
.pupup-content-inner {
	&.report-brand {
		padding: 0;

		p {
			color: @guidedRose;
			margin: 0 0 20px;
		}

		.button {
			margin: 20px 0 0;
		}
	}
	&.badge-info {
		display: flex;
		align-items: center;
		gap: 15px;
		.svg {
			width: 36px;
			flex-shrink: 0;
			flex-grow: 0;
		}
		p {
			margin: 0;
			padding: 0;
		}
	}
}
</style>